<template>
    <div class="pb-12 overflow-y-auto body-wrapper">
        <div class="px-4 lg:px-64 pb-16 pt-20 text-center lg:pt-32 bg-center bg-[#fafafa]">
            <h1
                class="font-display text-3xl xl:text-4xl 2xl:text-5xl font-bold tracking-tight text-slate-900 sm:text-5xl">
                中小非标机械厂
                <span class="relative whitespace-nowrap text-blue-600">
                    <svg aria-hidden="true" viewBox="0 0 418 42"
                        class="absolute left-0 top-2/3 h-[0.58em] w-full fill-blue-300/70" preserveAspectRatio="none">
                        <path
                            d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z">
                        </path>
                    </svg>
                    <span class="relative">ERP&MES</span>
                </span> 一体化管理系统
            </h1>
            <h3 class="mt-12 text-sm lg:text-2xl tracking-wide text-slate-700">
                管好交期与库存，效益增长快人一步
            </h3>
            <div class="flex items-center justify-center mt-6 text-sm lg:text-base tracking-wide text-[#666]">
                <div class="flex items-center">
                    <a-icon class="mr-1" type="check-circle" />即买即用
                </div>
                <div class="flex items-center ml-2">
                    <a-icon class="mr-1" type="check-circle" />无需实施
                </div>
                <div class="flex items-center ml-2">
                    <a-icon class="mr-1" type="check-circle" />操作简单
                </div>
                <div class="flex items-center ml-2">
                    <a-icon class="mr-1" type="check-circle" />3小时跑通
                </div>
            </div>
            <div class="mt-10 flex justify-center gap-x-6">
                <div class="text-white">
                    <a class="inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none bg-blue-600 hover:bg-blue-500"
                        variant="solid" color="slate" href="/apply" target="_blank">
                        体验Demo
                    </a>
                </div>
                <div class="text-blue-600 hover:text-blue-500">
                    <a class="inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none border border-blue-600"
                        variant="solid" color="slate" href="/apply" target="_blank">
                        预约演示
                    </a>
                </div>
            </div>
        </div>

        <div
            class="px-4 lg:px-24 xl:px-64 py-8 text-center lg:py-16 border-y bg-[linear-gradient(180deg,#d1f2fd,rgba(209,242,253,0))]">
            <div class="font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold">
                {{ steps.title }}
            </div>
            <div class="hidden lg:flex justify-center mt-6">
                <a-row class="mt-6" :gutter="16">
                    <a-col :span="8" v-for="item in steps.descs" :key="item.title">
                        <a-card style="height: 160px;" :title="item.title">
                            <p class="font-[600]">{{ item.desc }}</p>
                        </a-card>
                    </a-col>
                </a-row>
            </div>
            <div class="flex flex-col lg:hidden justify-center mt-6">
                <a-row class="mt-6" v-for="item in steps.descs" :key="item.title">
                    <a-card style="height: 160px;" :title="item.title">
                        <p class="">{{ item.desc }}</p>
                    </a-card>
                </a-row>
            </div>
        </div>

        <div class="px-4 lg:px-0 pt-8 text-center lg:pt-12 border-b">
            <div class="text-center">
                <div class="font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold">
                    聚焦 4 大核心功能模块，打造中小型非标机械厂数智化转型第一步
                </div>
                <a-tabs class="pt-2 lg:pt-4 text-lg" default-active-key="0" size="large" :animated="false">
                    <a-tab-pane v-for="(item, index) in modules" :key="String(index)">
                        <template #tab>
                            <span class="flex items-center text-sm lg:text-lg">
                                <!-- <a-icon type="project" :style="{ fontSize: '18px' }" /> -->
                                {{ item.tabTitle }}
                            </span>
                        </template>
                        <a-row
                            class="hidden lg:flex flex-col lg:flex-row justify-center items-center px-4 lg:px-24 xl:px-64 py-4 lg:py-16">
                            <a-col :span="6" style="height: 100%;">
                                <div class="flex flex-col justify-start">
                                    <p class="text-lg text-left tracking-wide sm:text-xl md:text-xl font-semibold">
                                        {{ item.title }}
                                    </p>
                                    <p class="max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6"
                                        v-for="itemDesc in item.descs" :key="itemDesc">
                                        <a-icon class="mr-2 text-base text-green-500" type="check" />
                                        {{ itemDesc }}
                                    </p>
                                </div>
                            </a-col>
                            <a-col :span="18">
                                <a-carousel class="ml-3 lg:ml-16 xl:ml-36 w-2/3 lg:w-[660px] rounded-xl mt-2 lg:mt-0"
                                    :dots="false" arrows autoplay>
                                    <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-index: 1">
                                        <a-icon type="left-circle" />
                                    </div>
                                    <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                        <a-icon type="right-circle" />
                                    </div>
                                    <img v-if="index === 0"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module1.png" />
                                    <img v-if="index === 0"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module2.png" />
                                    <img v-if="index === 1"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module3.png" />
                                    <img v-if="index === 1"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module4.png" />
                                    <img v-if="index === 2"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module5.png" />
                                    <img v-if="index === 2"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module6.png" />
                                    <img v-if="index === 2"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module7.png" />
                                    <img v-if="index === 3"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module8.png" />
                                    <img v-if="index === 3"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/module9.png" />
                                </a-carousel>
                            </a-col>
                        </a-row>
                        <div class="flex flex-col justify-center items-center lg:hidden px-4 py-8">
                            <div class="flex flex-col justify-start">
                                <p class="text-base text-center tracking-wide sm:text-xl md:text-xl font-semibold">
                                    {{ item.title }}
                                </p>
                                <p class="max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6"
                                    v-for="itemDesc in item.descs" :key="itemDesc">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    {{ itemDesc }}
                                </p>
                            </div>
                            <a-carousel class="w-5/6 lg:w-[660px] rounded-xl mt-2 lg:mt-0" :dots="false" arrows
                                autoplay>
                                <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-index: 1">
                                    <a-icon type="left-circle" />
                                </div>
                                <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                    <a-icon type="right-circle" />
                                </div>
                                <img v-if="index === 0"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module1.png" />
                                <img v-if="index === 0"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module2.png" />
                                <img v-if="index === 1"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module3.png" />
                                <img v-if="index === 1"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module4.png" />
                                <img v-if="index === 2"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module5.png" />
                                <img v-if="index === 2"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module6.png" />
                                <img v-if="index === 2"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module7.png" />
                                <img v-if="index === 3"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module8.png" />
                                <img v-if="index === 3"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/module9.png" />
                            </a-carousel>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>

        <div class="px-4 lg:px-0 pt-8 text-center lg:pt-12 border-b">
            <div class="text-center">
                <div class="font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold">
                    生产大管家的能力，体现在每个细节
                </div>
                <a-tabs class="pt-2 lg:pt-4 text-lg" default-active-key="0" size="large" :animated="false">
                    <a-tab-pane v-for="(item, index) in features" :key="String(index)">
                        <template #tab>
                            <span class="flex items-center text-sm lg:text-lg">
                                {{ item.title }}
                            </span>
                        </template>
                        <a-row
                            class="hidden lg:flex flex-col lg:flex-row justify-center items-center px-4 lg:px-24 xl:px-64 py-4 lg:py-16">
                            <a-col :span="6" style="height: 100%;">
                                <div class="flex flex-col justify-start">
                                    <p class="text-lg text-left tracking-wide sm:text-xl md:text-xl font-semibold">
                                        {{ item.title }}
                                    </p>
                                    <p
                                        class="max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6">
                                        {{ item.desc }}
                                    </p>
                                </div>
                            </a-col>
                            <a-col :span="18">
                                <a-carousel class="ml-3 lg:ml-16 xl:ml-36 w-2/3 lg:w-[660px] rounded-xl mt-2 lg:mt-0"
                                    :dots="false" arrows autoplay>
                                    <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-index: 1">
                                        <a-icon type="left-circle" />
                                    </div>
                                    <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                        <a-icon type="right-circle" />
                                    </div>
                                    <img v-if="index === 0"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/feature1.png" />
                                    <img v-if="index === 1"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/feature2.png" />
                                    <img v-if="index === 1"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/feature3.png" />
                                    <img v-if="index === 2"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/feature4.png" />
                                    <img v-if="index === 3"
                                        class="lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]"
                                        src="@/assets/imgs/home_products/feature5.png" />
                                </a-carousel>
                            </a-col>
                        </a-row>
                        <div class="flex flex-col justify-center items-center lg:hidden px-4 py-8">
                            <div class="flex flex-col justify-start">
                                <div class="text-base text-center tracking-wide sm:text-xl md:text-xl font-semibold">
                                    {{ item.title }}
                                </div>
                                <div
                                    class="max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6">
                                    {{ item.desc }}
                                </div>
                            </div>
                            <a-carousel class="w-5/6 rounded-xl mt-2 lg:mt-0" :dots="false" arrows autoplay>
                                <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-index: 1">
                                    <a-icon type="left-circle" />
                                </div>
                                <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                    <a-icon type="right-circle" />
                                </div>
                                <img v-if="index === 0"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/feature1.png" />
                                <img v-if="index === 1"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/feature2.png" />
                                <img v-if="index === 1"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/feature3.png" />
                                <img v-if="index === 2"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/feature4.png" />
                                <img v-if="index === 3"
                                    class="lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/feature5.png" />
                            </a-carousel>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>

        <div class="px-4 md:px-20 lg:px-24 xl:px-64 py-8 text-center lg:py-16 border-y">
            <div class="font-display tracking-tight text-lg lg:text-2xl mx-4 font-semibold">
                {{ envs.title }}
            </div>
            <div class="hidden lg:flex justify-center mt-6">
                <a-row style="width: 100%;" class="mt-6" :gutter="16">
                    <a-col :span="6" v-for="item in envs.descs" :key="item.title">
                        <a-card :title="item.title">
                            <p>{{ item.desc }}</p>
                        </a-card>
                    </a-col>
                </a-row>
            </div>
            <div class="flex flex-col lg:hidden justify-center mt-6">
                <a-row style="width: 100%;" class="mt-6" v-for="item in envs.descs" :key="item.title">
                    <a-card :title="item.title">
                        <p>{{ item.desc }}</p>
                    </a-card>
                </a-row>
            </div>
        </div>

        <div
            class="px-4 md:px-20 lg:px-24 xl:px-64 py-8 text-center lg:py-16 border-y bg-[linear-gradient(180deg,#c8f8e2,rgba(200,248,226,0))]">
            <div class="font-display tracking-tight text-lg lg:text-3xl mx-4 font-semibold">
                {{ customers.title }}
            </div>
            <div class="hidden lg:flex justify-center mt-6">
                <a-row class="mt-6" :gutter="16">
                    <a-col :span="8" v-for="item in customers.descs" :key="item.title">
                        <a-card class="mb-4" style="height: max-content;" :title="item.title">
                            <p class="font-[600]">{{ item.desc }}</p>
                        </a-card>
                    </a-col>
                </a-row>
            </div>
            <div class="flex flex-col lg:hidden justify-center mt-6">
                <a-row class="mt-6" v-for="item in customers.descs" :key="item.title">
                    <a-card style="height: max-content;" :title="item.title">
                        <p class="font-[600]">{{ item.desc }}</p>
                    </a-card>
                </a-row>
            </div>
        </div>

        <home-page-to-contact />
        <home-page-contact />
    </div>
</template>

<script>
import HomePageContact from './components/contact';
import HomePageToContact from './components/to-contact'

export default {
    name: 'homePageProducts',
    components: {
        HomePageContact,
        HomePageToContact
    },
    data() {
        return {
            steps: {
                title: '以生产管理为核心，助力中小型非标机械厂实现更低成本的快速出货',
                descs: [
                    { title: '数字化经营与管理', desc: '整合产品全生命周期数据，实现生产透明化，提升生产效率' },
                    { title: '多部门高效协同', desc: '支持销售、计划、工艺、生产、质量、库房、财务跨部门业务，打破数据孤岛，驱动产品流动速度不断加快' },
                    { title: '可视化分析与决策', desc: '随时随地查看工厂全局数据，了解进度、趋势、异常' },
                ]
            },
            modules: [
                {

                    tabTitle: '报价接单',
                    title: '快速响应场需求，提升客户满意度',
                    descs: [
                        '自动成本核算，报价快人一步',
                        '订单数据一键导入，订单交期实时预警'
                    ],
                    // TODO: 直接如此在模板中使用时 webpack 不会自动解析
                    imgs: [
                        '@/assets/imgs/home_products/module1.png',
                        '@/assets/imgs/home_products/module2.png',
                    ]
                },
                {
                    tabTitle: '计划排产',
                    title: '智能排产优化，提升生产效率与资源利用',
                    descs: [
                        '生产任务一键下达，助力车间高效生产',
                        '辅助智能排产，减少产品停留等待时间，加快产品流动速度'
                    ],
                    imgs: [
                        '@/assets/imgs/home_products/module3.png',
                        '@/assets/imgs/home_products/module4.png',
                    ]
                },
                {
                    tabTitle: '生产制造',
                    title: '实时监控生产状态，确保产品质量与进度',
                    descs: [
                        '扫码报工，随时掌握生产进度打破车间黑匣子',
                        '产品质量数据实时记录，实现质量问题可追溯和预防',
                        '系统支持在线编制工艺卡片，车间可随时随地查看产品工艺'
                    ],
                    imgs: [
                        '@/assets/imgs/home_products/module5.png',
                        '@/assets/imgs/home_products/module6.png',
                        '@/assets/imgs/home_products/module7.png',
                    ]
                },
                {
                    tabTitle: '仓储物流',
                    title: '精确管理库存，减少成本，提升物流效率',
                    descs: [
                        '产品库存数据自动生成，助力优化库存水平',
                        '库存数据实时准确，库管人员能及时发现库房呆滞料，避免库存过多带来的资金占用'
                    ],
                    imgs: [
                        '@/assets/imgs/home_products/module8.png',
                        '@/assets/imgs/home_products/module9.png',
                    ]
                },
            ],
            features: [
                {
                    title: '库存智能匹配',
                    desc: '生产计划下达支持智能匹配库房库存，有效避免重复生产',
                },
                {
                    title: '异常场景处理',
                    desc: '检验、库管等因人为失误导致系统数据出错的场景均支持撤回操作，保证系统数据如实反应实际生产情况',
                },
                {
                    title: '智能数据分析',
                    desc: '帮助工厂精准识别瓶颈资源，挖掘瓶颈潜力，优化排产计划，从而加快产品流动，缩短生产周期，解决库存和订单交期管理的难题。',
                },
                {
                    title: '个性化配置',
                    desc: '字段、流程、页面、权限等灵活丰富的自定义配置功能，更好地适应工厂的生产环境和业务流程',
                },
            ],
            envs: {
                title: '多个环境下，随时随地管理车间现场',
                descs: [
                    {
                        title: '管理层',
                        desc: '随时随地用监控关键指标',
                    },
                    {
                        title: '业务主管',
                        desc: '周期性的数据统计、分析、优化',
                    },
                    {
                        title: '车间现场',
                        desc: '查看关键数据，快速优化作业瓶颈',
                    },
                    {
                        title: '经营驾驶舱',
                        desc: '随时随地监控生产进度',
                    },
                ]
            },
            customers: {
                title: '客户证言',
                descs: [
                    {
                        title: '机械加工行业客户A',
                        desc: '“轻熵科技给我们非标定制的这款ERP&MES一体化管理系统还是不错的，超交期的订单能精确查到在哪个工位，停留多少时间。当天完成的货也能马上看到。每天客户下的订单什么时候到车间也能清楚。以后可以告别写黑板了。”',
                    },
                    {
                        title: '机械加工行业客户B',
                        desc: '“用了轻熵科技的一体化ERP&MES系统后，最直观的感受是跟单、盯活节省了很多时间，可以去做其他的事情。系统可以通过扫码报工自动跟单，各环节数据实现了自动流转，极大减少非增值时间浪费，从而加快产品流转速度，缩短产品生产周期。现在我们算是生产管理理念和水平都很靠前的，我们的口碑和声誉也打出去了。”'
                    },
                    {
                        title: '机械加工行业客户C',
                        desc: '上线周期短，整体成本低，项目成功率100%，工人快速上手易接手，培训成本低，售后服务好。',
                    },
                ]
            },
        }
    }
}
</script>
<style scoped>
.body-wrapper {
    height: 100%;
}

.title-desc {
    background-color: #eef4ff;
}

.ant-statistic>>>.ant-statistic-title {
    color: black;
    font-weight: 500;
    font-size: 16px;
}

.ant-tabs>>>.ant-tabs-content {
    background-color: #fafafa;
}

.ant-carousel>>>.custom-slick-arrow {
    width: 30px;
    height: 30px;
    font-size: 30px;
    color: #0086ff;
    background-color: transparent;
    opacity: 0.6;
}

.ant-carousel>>>.slick-prev {
    margin: -52px 0 0 -52px;
}

.ant-carousel>>>.slick-next {
    margin: -52px -52px 0 0;
}

.ant-carousel>>>.custom-slick-arrow:before {
    display: none;
}

.ant-carousel>>>.custom-slick-arrow:hover {
    opacity: 0.8;
}

@media only screen and (max-width: 480px) {
    .ant-carousel>>>.custom-slick-arrow {
        width: 20px;
        height: 20px;
        font-size: 20px;
    }

    .ant-carousel>>>.slick-prev {
        margin: -22px 0 0 -38px;
    }

    .ant-carousel>>>.slick-next {
        margin: -22px -38px 0 0;
    }
}
</style>
